import Link from "@mui/material/Link"
import Stack from "@mui/material/Stack"
import { fetchRoute, Typography } from "@cakemail-org/ui-components-v2"
import { ERoutes } from "../../../utils/url"

export function EventDetail({ leftText, righttext, link }: { leftText: string, righttext?: string, link?: string }) {
    return <Stack direction="row" className="eventDetail">
        <Typography variant="body1" className="semiBold">{leftText}</Typography>
        {link && <Link href={link} ><Typography>{righttext}</Typography></Link>}
        {!link && <Typography>{righttext}</Typography>}
    </Stack>
}